// @flow
import React from "react";
import { Form } from "react-bootstrap";
import * as layoutConstants from "../../data/layout";

/**
 * Componente para el tema de la barra lateral izquierda
 *
 * @param {Object} props - Propiedades del componente
 * @param {Function} props.changeLeftSidebarTheme - Función para cambiar el tema de la barra lateral izquierda
 * @param {String} props.leftSideBarTheme - Tema de la barra lateral izquierda
 * @param {Object} props.layoutConstants - Constantes de disposición
 * @returns {JSX.Element} Componente de React
 */
const LeftSideBarTheme = ({
  changeLeftSidebarTheme,
  leftSideBarTheme,
  layoutConstants,
}) => {
  return (
    <>
      <h5 className="mt-4">Tema de la barra lateral izquierda</h5>
      <hr className="mt-1" />

      <Form.Check className="form-check form-switch mb-1">
        <Form.Check.Input
          type="radio"
          name="theme"
          id="brand-check"
          value={layoutConstants.LEFT_SIDEBAR_THEME_DEFAULT}
          onChange={(e) => changeLeftSidebarTheme(e.target.value)}
          checked={
            leftSideBarTheme === layoutConstants.LEFT_SIDEBAR_THEME_DEFAULT
          }
        />
        <Form.Check.Label htmlFor="brand-check">Defecto</Form.Check.Label>
      </Form.Check>

      <Form.Check className="form-check form-switch mb-1">
        <Form.Check.Input
          type="radio"
          name="theme"
          id="light-check"
          value={layoutConstants.LEFT_SIDEBAR_THEME_LIGHT}
          onChange={(e) => changeLeftSidebarTheme(e.target.value)}
          checked={
            leftSideBarTheme === layoutConstants.LEFT_SIDEBAR_THEME_LIGHT
          }
        />
        <Form.Check.Label htmlFor="light-check">Claro</Form.Check.Label>
      </Form.Check>

      <Form.Check className="form-check form-switch mb-1">
        <Form.Check.Input
          type="radio"
          name="theme"
          id="dark-check"
          value={layoutConstants.LEFT_SIDEBAR_THEME_DARK}
          onChange={(e) => changeLeftSidebarTheme(e.target.value)}
          checked={leftSideBarTheme === layoutConstants.LEFT_SIDEBAR_THEME_DARK}
        />
        <Form.Check.Label htmlFor="dark-check">Oscuro</Form.Check.Label>
      </Form.Check>
    </>
  );
};

export default LeftSideBarTheme;
